export const CLOUDPAYMENTS_PUBLIC_ID_DEV = process.env.REACT_APP_CLOUDPAYMENTS_PUBLIC_ID_DEV;
